var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HqLayout',{attrs:{"hasFilter":false,"tag":"audit-log-page","title":_vm.$t('AuditLog.PageTitle')}},[_c('DataTables',{attrs:{"tableOptions":_vm.tableOptions,"noSearch":"","exportable":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }